import { Component, Input, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MovimentacaoService } from '@app/services/movimentacao.service';
import { PagarService } from '@app/services/pagar.service';
import { ReceberService } from '@app/services/receber.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';

import { transition, trigger, animate, style } from '@angular/animations';
import { Baixa, BaixaFormaDePagamento, BaixaInformacoes } from '@app/models/baixa.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { PagarListaFiltros, PagarLista } from '@app/models/pagar.model';
import { PagarListaComponent } from '../pagar/pagar-lista/pagar-lista.component';
import { ParticipanteService } from '@app/services/participante.service';

@Component({
  selector: 'app-baixa',
  templateUrl: 'baixa.component.html',
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('250ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms', style({ opacity: 0 }))
      ])
    ]
    )
  ]
})

export class BaixaComponent implements OnInit {

  tipo = '';
  descricao = '';
  descricaoPagoOuRecebido: string;

  processoId = 0;

  valorTitulo = 0;
  juros = 0;
  desconto = 0;
  valorRecebido = 0;
  valorJaPago = 0;

  historico = '';

  baixaParcial = false;
  parcialNovoNumero = '';
  parcialVencimento = '';
  parcialValor: number;

  lstErros: string[] = [];

  baixaInformacoes = new BaixaInformacoes();

  formaDePagamento = new BaixaFormaDePagamento();
  baixa = new Baixa();
  lstContas: IdDescricao[] = [];
  formas: IdDescricao[] = [];
  bancosCadastrados: IdDescricao[] = [];
  PagarListaComponent: PagarListaComponent;
  MovimentarTodosOsCaixas: boolean = false;
  troco:boolean = true;

  @Input() modalTipo: string = '';
  @Input() modalId: number = 0;
  @Output() fecharModal = new EventEmitter();
  @Output() pesquisarNovamenteModal = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private receberService: ReceberService,
    private pagarService: PagarService,
    @Inject(ToastrService) public toastr: ToastrService,
    private consultasService: ConsultasService,
    private movimentacaoService: MovimentacaoService,
    private participanteService: ParticipanteService
  ) {
    this.baixa.valor = 0;
    this.baixa.trocoContaId = null;
    this.formaDePagamento.valor = 0;
  }

  ngOnInit() {    
    this.route.params.subscribe(
      (params: any) => {
        let id = this.modalId === 0 ? params['id'] : this.modalId ;
        this.tipo = (this.modalTipo === '' ? params['tipo'] : this.modalTipo).toUpperCase();
        this.baixa.processoId = params['processoId'];

        if (this.tipo !== 'RECEBER' && this.tipo !== 'PAGAR') {
          this.router.navigate(['./dashboard']);
        }

        this.obterInformacoesTitulo(id);
        this.preencherDropdown();
      }
    );
  }

  obterInformacoesTitulo(id: number) {
    if (this.tipo === 'RECEBER') {
      this.descricao = 'RECEBIMENTO';
      this.baixa.Tipo = this.tipo;
      this.descricaoPagoOuRecebido = 'Recebido';

      this.receberService.obterPorId(id)
        .subscribe(
          data => {
            this.populaDados(data);
          },
          () => {
            if(this.baixa.processoId){
              this.router.navigate(['/processos/processo', this.baixa.processoId, 'financeiro']);
            }
            else{
              this.fecharModal.emit();
            }
          }
        );
    }
    if (this.tipo === 'PAGAR') {
      this.descricao = 'PAGAMENTO';
      this.baixa.Tipo = this.tipo;
      this.descricaoPagoOuRecebido = 'Pago';

      this.pagarService.obterPorId(id)
        .subscribe(
          data => {
            this.populaDados(data);
            this.preencherDadosJaPagos(data);
          },
          () => {
            if(this.baixa.processoId){
              this.router.navigate(['/processos/processo', this.baixa.processoId, 'financeiro']);
            }
            else{
              this.fecharModal.emit();
            }
          }
        );
    }
  }

  preencherDadosJaPagos(data: any){
    this.baixa.valorRestante =  data.Valor - data.ValorPago;
    this.valorJaPago = data.ValorPago;
    this.baixa.valorRecebido = data.ValorPago;
  }

  populaDados(data: any) {
    this.baixa.documentoId = data.Id;
    this.baixa.valor = this.valorTitulo = data.Valor;

    this.parcialVencimento = data.Vencimento?.split('T')[0];
    this.parcialNovoNumero = data.Numero;
    this.valorRecebido = this.valorTitulo + this.juros - this.desconto;
    this.parcialValor = (this.valorTitulo + this.juros - this.desconto) - this.valorRecebido;

  }

  protected preencherDropdown() {
    this.participanteService.verificaPermissaoUsuario(0, 'MovimentarTodosOsCaixas')
      .subscribe(
      () => this.consultasService.consultar('CONTA').subscribe(permissao => this.lstContas = permissao),
      () => this.consultasService.consultar('CONTA_USUARIO').subscribe(permissao => this.lstContas = permissao)
    );
    
    this.consultasService.consultar('BANCO').toPromise()
      .then(data => this.bancosCadastrados = data);
    if (this.tipo === 'RECEBER') {
      this.consultasService.consultar('FORMADEPAGAMENTO_C').toPromise()
        .then(data => this.formas = data);
    } else {
      this.consultasService.consultar('FORMADEPAGAMENTO_D').toPromise()
        .then(data => this.formas = data);
    }
  }
  
  atualizaValor() {
    this.baixa.valor = (this.desconto >= this.baixa.valor) ? 0 : this.valorTitulo - this.desconto + this.juros;

    this.parcialValor = (this.valorTitulo + this.juros - this.desconto);
  }

  btnVoltar() {
    if (this.baixa.processoId) {
      this.router.navigate(['/processos/processo', this.baixa.processoId, 'financeiro']);
    } else {
      this.fecharModal.emit();
    }
  }

  inserirFormaPagamento() {
    if (this.formaDePagamento.formaDePagamentoId === 0) {
      this.toastr.info('Selecione uma forma de pagamento');
      return;
    }

    if (this.formaDePagamento.contaId === 0) {
      this.toastr.info('Selecione uma conta');
      return;
    }

    if (this.formaDePagamento.valor <= 0) {
      this.toastr.info('O valor tem que ser maior que zero');
      return;
    }

    const contaEncontrada = this.lstContas.find(x => x.Id === this.formaDePagamento.contaId);
    if (contaEncontrada) {
      this.formaDePagamento.contaDescricao = contaEncontrada.Descricao;
    }
    const fpEncontrada = this.formas.find(x => x.Id === this.formaDePagamento.formaDePagamentoId);
    if (fpEncontrada) {
      this.formaDePagamento.formaDePagamentoDescricao = fpEncontrada.Descricao;
    }
    if (this.formaDePagamento.CadastrarCheque) {
      if (this.validaCheque(this.formaDePagamento) === false) {
        return;
      }
      const bancoEncontrado = this.bancosCadastrados.find(x => x.Id === this.formaDePagamento.ChequeBancoId);
      if (bancoEncontrado) {
        this.formaDePagamento.ChequeBancoDescricao = bancoEncontrado.Descricao;
      }
    }

    this.baixa.formaDePagamento.push(this.formaDePagamento);
    this.calcularValores();

    this.formaDePagamento = new BaixaFormaDePagamento(this.formaDePagamento.formaDePagamentoId, this.formaDePagamento.contaId);
  }

  validaCheque(formaDePagamento: BaixaFormaDePagamento) {
    if (!formaDePagamento.ChequeBancoId || formaDePagamento.ChequeBancoId < 1) {
      this.toastr.error('Banco  do cheque não informado');
      return false;
    }

    if (!formaDePagamento.ChequeAgencia) {
      this.toastr.error('Agência do cheque não informada.');
      return false;
    }

    if (!formaDePagamento.ChequeConta) {
      this.toastr.error('Conta  do cheque não informada.');
      return false;
    }

    if (!formaDePagamento.ChequeNumero) {
      this.toastr.error('Número do cheque não informado.');
      return false;
    }

    if (!formaDePagamento.ChequeTitular) {
      this.toastr.error('Titular do cheque não informado.');
      return false;
    }


    if (!formaDePagamento.ChequeDataEmissao) {
      this.toastr.error('Data de emissão do cheque não informada.');
      return false;
    }


    if (!formaDePagamento.ChequeDataVencimento) {
      this.toastr.error('Data de vencimento do cheque não informada.');
      return false;
    }


  }

  chequeProprio() {

    const contaEncontrada = this.lstContas.find(x => x.Id === this.formaDePagamento.contaId);
    if (contaEncontrada) {
      this.formaDePagamento.ChequeBancoId = contaEncontrada.Extra1;
      this.formaDePagamento.ChequeAgencia = contaEncontrada.Extra2;
      this.formaDePagamento.ChequeConta = contaEncontrada.Extra3;
      this.formaDePagamento.ChequeTitular = contaEncontrada.Extra4;
    }

  }

  deletar(index: number) {
    this.baixa.formaDePagamento.splice(index, 1);
    this.calcularValores();
  }

  calcularValores() {
    this.baixa.valorRecebido = this.baixa.formaDePagamento.reduce((sum, current) => sum + current.valor, 0) + this.valorJaPago;
    this.baixa.valorRestante = this.baixa.valor - this.baixa.valorRecebido;

    if (this.baixa.valorRecebido > this.baixa.valor) {
      this.baixa.valorRestante = 0;
      this.baixa.valorTroco = Number((this.baixa.valorRecebido - this.baixa.valor).toFixed(2));
    } else {
      this.baixa.valorTroco = 0;
    }

    this.parcialValor = this.baixa.valorRestante;

    if(this.baixa.valorRestante !== 0) {
      this.baixaParcial = true;
    } else {
      this.baixaParcial = false;
    }

  }

  verificarCadastrarCheque(formaDePagamentoId: number) {
    const fpEncontrada = this.formas.find(x => x.Id === formaDePagamentoId);
    if (fpEncontrada) {
      return fpEncontrada.Extra1;
    }
    return false;
  }

  validarBaixa() {
    if(this.baixa.formaDePagamento.length == 0){
      this.toastr.error('Valor do pagamento obrigatório!');
      return;
    }

    if (this.baixaParcial) {
      if (!this.parcialValor) {
        this.toastr.error('Valor restante incorreto!');
        return;
      }

      if (!this.parcialVencimento) {
        this.toastr.error('Favor informar data de vencimento para novo título!');
        return;
      }
    }

    if (this.troco && this.baixa.valorTroco > 0 && this.baixa.trocoContaId == null) {
      this.toastr.error('Selecione a conta para o troco!');
      return;
    }

    this.realizarBaixa();
  }


  radioCreditoTroco(tipo: string){
    switch(tipo){
        case 'troco':
        this.baixaInformacoes.Credito = false;
        this.troco = true;
        break;
        case 'credito':
        this.baixaInformacoes.Credito = true;
        this.troco = false;
        break;
    }  
  };

  realizarBaixa() {
    const newTab = window.open();

    // historico Receber
    this.baixaInformacoes.Troco = this.baixa.valorTroco;
    this.baixaInformacoes.Desconto = this.desconto;
    this.baixaInformacoes.Juros = this.juros;
    this.baixaInformacoes.Numero = this.parcialNovoNumero;
    this.baixaInformacoes.Historico = this.historico;
    this.baixaInformacoes.DataBaixa = this.baixa.dataPagamento;
    this.baixaInformacoes.NovoVencimento = this.parcialVencimento;

    if(this.baixa.valorTroco > 0){
      this.baixa.formaDePagamento.forEach(forma => {
        var porcentagem = forma.valor/ this.baixa.valorRecebido;
        forma.valorReal = forma.valor;
        forma.valor = Number((this.baixa.valor * porcentagem).toFixed(2));
        //vai pro banco CreditoHistorico
        forma.valorTroco = forma.valorReal - forma.valor;
      });
    }


    this.movimentacaoService.baixar(this.baixa, this.baixaInformacoes)
      .toPromise().then(
        (data: any) => {
          if (this.baixa.Tipo.toUpperCase() === 'RECEBER') {
            newTab.location.href = window.location.href.split('#')[0] +
              '#/recibo/R/' + this.baixa.documentoId;
          } else {
            newTab.location.href = window.location.href.split('#')[0] +
              '#/recibo/P/' +  data._pagarId;
          }
          {
            if(this.baixa.processoId){
              this.router.navigate(['/processos/processo', this.baixa.processoId, 'financeiro']);
            }
            else{
              this.fecharModal.emit();
              this.pesquisarNovamenteModal.emit();
            }
          }
        },
        (data) => {
          newTab.close();
          this.toastr.error('Não foi possível efetuar a baixa!');
        }
      );
  }

  ativaCheque() {
    const valorCampo = this.formas.find((item) =>
      item.Id === this.formaDePagamento.formaDePagamentoId);

    this.formaDePagamento.CadastrarCheque = <boolean>valorCampo.Extra2;
  }
}
